// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3qnJS","footer":"ModalCreateQualiphyProcedure_footer__33Tm4","additionData":"ModalCreateQualiphyProcedure_additionData__1FA5k"};